
import { defineComponent } from 'vue'

import { useWalletStore } from '@/stores/wallet'

export default defineComponent({
  setup() {
    const walletStore = useWalletStore()

    const connectWallet = async () => {
      try {
        // @ts-expect-error Window.ethereum not typed
        const data = await window.ethereum.request({
          method: 'eth_requestAccounts',
        })
        console.log('data :>> ', data)
        // this.userAddress = data[0]
        walletStore.saveWalletData(data[0])
        console.log('DApp connected to your wallet 💰')
      } catch (error) {
        console.error('Error connecting DApp to your wallet')
      }
    }
    return {
      connectWallet,
      walletStore,
    }
  },
})
